import CertificateRegistration from './CertificateRegistration';
export default CertificateRegistration;
